<!--
利用規約画面
URL：/tos
表示条件：ログイン済みであること
-->

<template>
  <v-container>
    <div class="text-h4 mt-8">水産プラットフォーム 利用規約</div>
    <v-card flat>
      <v-card-text>
水産プラットフォーム 利用規約（以下「本規約」といいます）は、広島県が主体となり水産プラットフォームを通じて本サービスをお申込み頂いたかき生産者等の利用者（以下「利用者」といいます）に提供する海洋情報および生産記録等を管理することでかき養殖の生産安定化を目的とした水産プラットフォームサービス（以下「本サービス」といいます）を、利用者がご利用いただくための条件を定めるものです。本サービスの利用にあたっては、本規約の内容についてご同意の上、ご利用いただくようお願いします。<br>
<br>
第１条（規約の適用）<br>
１．利用者は本規約に同意することで、本サービスを利用いただけます。<br>
２．広島県が本サービスの利用に関する条件を、本規約に加えて別途定めた場合、当該条件は本規約の一部を構成するものとします。<br>
３．本規約の内容と、前項の別途定めた条件が矛盾する場合は、別途定めた条件が優先して適用されるものとします。<br>
４．本規約の他に、本サービスに関連して個別サービスの規約が定められている場合は、その個別サービスにおいては個別の規約が優先的に適用されるものとします。<br>
<br>
第２条（本サービスの内容）<br>
本サービスの内容は、下記の各号に定めるとおりです。 <br>
(1) 利用者が行っている日々の作業や生産の記録、センサーで取得した海洋情報および気象庁が公開している情報を遠隔から一括して管理することや、利用者の情報を遠隔操作することができるシステムの提供。<br>
(2) 利用者からの本サービスについてのお問い合わせへの対応。<br>
(3) 本サービスに関する下記情報のご提供。<br>
&emsp;① 本サービスのシステムメンテナンス情報。<br>
&emsp;② サービスの不具合等重要な注意情報。<br>
(4) 利用者が行うサービスの遠隔操作を、広島県が必要かつ可能と認める場合に代行するサービスの提供。<br>
<br>
第３条（本サービスの利用料・利用期間等）<br>
１．本サービスは令和５年度末まで広島県水産業スマート化推進事業により運営されるため，無料でご利用いただけます。<br>
２．本サービスの解約手続き等については、広島県へお問合せください。<br>
<br>
第４条（本サービスの利用区域）<br>
本サービスの利用区域は、日本国内とします。日本国外ではご利用いただけません。<br>
<br>
第５条（本サービスの申込み資格）<br>
本サービスをご利用いただける利用者は、広島県の合意をいただいた方に限定します。<br>
<br>
第６条（本サービスの申込み）<br>
１．利用者は、あらかじめ本規約に同意の上、広島県へ所定の方法で、申込みに必要な情報を広島県に提出することによって手続を行っていただきます。<br>
２．広島県は、利用者の申込みを受け付けた後、必要な審査を行い、広島県が利用の可否を決定します。<br>
３．広島県は、以下に定める場合には、利用を認めないことがあります。<br>
&emsp;(1) サービス利用申込みをされた利用者が実在しない場合<br>
&emsp;(2) 利用者が届出ている電子メールアドレス等の連絡先に連絡がとれない場合<br>
&emsp;(3) 利用者が届出ている情報に虚偽またはこれに類する不正確な内容が含まれていることが判明した場合<br>
&emsp;(4) 利用者が、本規約に基づくサービスの利用を停止されたことがある等、広島県が利用者の利用またはサービス利用申込みを承諾すべきではないと判断した場合<br>
&emsp;(5) 広島県および委託業者の業務遂行上または技術上の支障がある場合<br>
&emsp;(6) その他広島県が不適当と認めた場合<br>
４．前項により利用を認めないときは、広島県は利用者にその旨を通知します。ただし、理由は開示しません。<br>
５．広島県は、申込みを承諾した場合、利用者に申込み手続きの完了を通知します。なお、広島県において申込み手続きが完了した時点で、広島県と利用者の間で本サービス利用の契約（以下「本契約」といいます）が成立するものとします。<br>
<br>
第７条（アカウントおよびパスワード）<br>
１．本サービスを利用するにあたり、利用者は本サービスにログインするためのアカウントおよびパスワード（以下「アカウント等」といいます）を取得していただく必要があります。アカウント等は、前条の申込み手続き完了後、広島県から利用者に通知します。<br>
２．利用者はアカウント等の管理およびその使用、ならびにアカウント等を用いて本サービスに登録した情報の正確性に関して、一切の責任を自身で負うものとします。<br>
３．利用者は、アカウントとして登録したメールアドレスを、広島県から利用者に対する通知、連絡を行うためのメールアドレスとして指定したものとします。当該メールアドレスに対する広島県の電子メールの送信は、広島県から利用者への意思表示または事実の伝達とみなされます。<br>
４．利用者はアカウント等を第三者に利用させないものとします。本サービスにおいてアカウント等を使用された場合、そのアカウント等を保有する利用者が本サービスを利用したものとみなします。<br>
５．利用者は、自己のアカウント等の盗難、紛失またはこれらが第三者に使用されていることが判明した場合、直ちに広島県にその旨を連絡するとともに、広島県から指示がある場合はこれに従います。<br>
６．利用者は、アカウント等を第三者に譲渡すること、貸与することはできません。<br>
７．広島県は、アカウント等の窃用による利用者の損害または利用者が第三者に与えた損害について、責任を負わないものとします。<br>
<br>
第９条（禁止行為等）<br>
１．利用者は下記の行為をしてはなりません。<br>
&emsp;(1) 本サービスの運営を妨げる行為（情報の改ざん、不正アクセス、コンピューターウィルス等の送信）<br>
&emsp;(2) 本サービスの利用に当たって虚偽の内容を申請する行為<br>
&emsp;(3) 第三者のアカウント等を不正に使用する行為<br>
&emsp;(4) 広島県または第三者の著作権等の知的財産権、その他の権利を侵害する行為<br>
&emsp;(5) 広島県もしくは第三者を誹謗中傷し、または名誉もしくは信用を傷つけるような行為<br>
&emsp;(6) 法令に違反し、または公序良俗に反する行為<br>
&emsp;(7) 本規約のいずれかに違反する行為<br>
&emsp;(8) その他広島県が不適切と判断する行為<br>
２．広島県は、利用者の行為が以下の項目のいずれかに該当する場合、利用者への事前通知のうえ、アカウント等の使用停止等、本サービスの提供停止、利用制限等をすることができるものとします。ただし、緊急の場合はこの限りではありません。<br>
&emsp;(1) 前項の禁止事項の一つに該当する場合<br>
&emsp;(2) 電話、FAX、Eメールその他の手段によっても、連絡が取れなくなった場合<br>
&emsp;(3) 第６条（サービスの申込み）第3項に定める利用を認めない事由に該当する場合<br>
&emsp;(4) その他、広島県が不適切と判断した場合<br>
<br>
第10条（本サービスの中断・停止等）<br>
広島県は、次の各号の事由が生じた場合は、利用者に対する事前の通知なく、本サービスの全部または一部を一時的に中断または停止することができます。これにより利用者または第三者に損害が生じたとしても、広島県は一切責任を負いません。<br>
&emsp;(1) システムの緊急の保守点検、修理、工事が必要な場合<br>
&emsp;(2) 電気通信事業者（電話通信事業会社、インターネットプロバイダー等）の役務が提供されない（通信停止事態）場合<br>
&emsp;(3) 天災地変、事変、停電が発生または発生する恐れがあり本サービスの提供ができない場合、また広島県が提供不可能と判断した場合<br>
&emsp;(4) その他やむを得ない事由が生じて広島県が中断停止を必要と判断した場合<br>
<br>
第11条（知的財産権）<br>
１．本サービスに係る知的財産権は、広島県または広島県が利用許諾を受けている第三者に帰属します。本規約に基づく利用者への本サービスの提供は、利用者に対する何らかの権利移転等を意味するものではありません。<br>
２．本サービスに第三者の商標が含まれる場合、当該商標は当該第三者に帰属するものであり、当該第三者が広島県と関係会社であることを示すものではなく、また、当該第三者による何らかの承認を示すものでもありません。<br>
<br>
第12条（お問い合わせ）<br>
利用者からのお問い合わせは、以下のサポート・お問い合わせページからお願いいたします。<br>
&emsp;広島県農林水産局水産課&emsp;水産振興グループ<br>
&emsp;電話&emsp;082-513-3610<br>
&emsp;メール&emsp;nousuisan@pref.hiroshima.lg.jp<br>
<br>
第13条（各種情報の取扱い）<br>
本サービスの提供にあたり広島県が取得する利用者の情報の取扱いについては、本規約に附帯して別途定める「水産プラットフォーム プライバシーポリシー」をご参照ください。利用者が本サービスを利用される時点において、「水産プラットフォーム プライバシーポリシー」の適用を受けることについて同意するものとします。<br>
<br>
第14条（再委託）<br>
広島県は、本サービスの提供に関する業務の全部または一部を第三者に再委託できるものとします。<br>
<br>
第15条（秘密保持）<br>
1. 広島県および利用者は、本契約に関連して知り得た相手方の全ての情報を秘密として厳重に管理するものとし、書面による相手方の事前の承諾を得ないで第三者に開示もしくは漏洩し、本契約の履行の目的以外に使用し、または第三者に使用させる等の行為をしてはならないものとします。ただし、次の各号の一に該当するものは、この限りではありません。<br>
&emsp;(1) 公知・公用のもの<br>
&emsp;(2) 知得した後、自己の責によらずに公知・公用となったもの<br>
&emsp;(3) 知得した際、既に自ら所有していたことを立証し得るもの<br>
&emsp;(4) 正当な権限を有する第三者から秘密保持義務を負うことなしに入手したもの<br>
&emsp;(5) 知得した後、知得した情報とは関係なく、独自に創出したことを立証し得るもの<br>
&emsp;(6) 法令に基づき開示されるもの<br>
２．前項の規定にかかわらず、広島県は、本契約の履行に必要な範囲で、業務委託先等の第三者に利用者の秘密情報を開示できるものとし、この場合、広島県が当該第三者に対し前項と同等の秘密保持義務を課すものとします。<br>
３．広島県および利用者は、本サービス提供のために必要な範囲で相手方の秘密情報を複製することができるものとし、当該複製物についても本条の定めが適用されるものとします。<br>
４．広島県および利用者は、相手方から要求があった場合、または本契約が終了した場合、遅滞なく秘密情報を相手方に返却または破棄もしくは消去するものとします。<br>
<br>
第16条（権利義務の譲渡制限等）<br>
利用者は、本規約に基づく本サービスのご利用に関わる権利および義務を第三者に譲渡し、またはそれに準ずる行為をすることはできないものとします。<br>
<br>
第17条（本サービスの内容の変更）<br>
広島県は、広島県の都合により、本サービスの内容や提供条件の全部または一部の変更を行うことができるものとします。内容や提供条件を変更する場合、広島県は事前に電子メールで通知するものとします。なお、広島県は、当該変更により利用者または第三者が被った損害について一切の責任を負いません。<br>
<br>
第18条（本サービスの廃止）<br>
１．広島県は、広島県の都合により、本サービスの全部または一部を一時的にまた永続的に廃止することがあります。<br>
２．広島県は、本サービスを廃止する場合は、緊急の場合を除いて広島県が適当と判断する方法で事前に利用者にその旨通知します。<br>
<br>
第19条（免責事項）<br>
１．広島県は、利用者の本サービスのご利用およびご利用の結果について、一切責任を負いません。<br>
２．利用者から送信された情報に関して、記入漏れ・メールアドレスの誤入力・判読不能な文字化け現象などが原因で利用者が損害を被った場合、広島県は一切その責任を負いません。<br>
３．本サービスを利用するにあたり、利用者に生じたシステム上の損害（ハードウェア・ソフトウェアを問わず）について、広島県は一切その責任を負いません。<br>
４．利用者の本サービスのご利用にあたり、本サービスに関し、利用者が本サービスに設定または登録したデータが破損、消失または変更された場合、広島県は一切責任を負いません。<br>
５．本サービスには個人情報を入力する画面にSSLという暗号化技術を使用しておりますが、その安全性については広島県によって保証されるものではありません。<br>
６．本規約に基づく広島県の責任は、日本国法令を遵守し、本サービスを利用者に提供する範囲に限定されるものとします。<br>
７．利用者は、善良なる管理者の注意義務を持って本サービスを利用者に提供しますが、提供する情報内容についての正確性、有用性等について一切保証するものではありません。また、広島県は利用者に対しその責任を負いません。<br>
８．広島県は、理由の如何を問わず、本サービスの提供が遅延、変更、中断、中止、廃止したことに起因して利用者または第三者が被った損害について責任を負いません。<br>
９．本サービスに関連して、第三者の名誉・信用を傷つける行為、知的財産権、その他の権利の侵害等があったとして、利用者と第三者との間で紛争等が発生した場合においても、広島県はいかなる責任も負いません。また、当該紛争等により広島県が第三者等から損害賠償の請求等を受けた場合、利用者は広島県を防御し、広島県が被った損害を賠償するものとします。<br>
10．利用者および第三者による本サービスの利用または利用不能から生じるいかなる損害についても、広島県は一切責任を負いません。また、利用者は、本サービスの利用に関して第三者に損害が生じた場合、利用者の責任と費用負担で解決するものとし、広島県を免責せしめるものとします。<br>
11．前各項の規定にかかわらず、本契約に関連して、広島県の故意または重大な過失に起因して広島県が利用者に損害を与えた場合においては、利用者が被った損害を賠償する義務を負わないものとします。<br>
<br>
第20条（反社会的勢力）<br>
広島県は、反社会的勢力（暴力団、暴力団構成員、暴力団関係者等）またはその関係者の方に対してはご利用をお断りしています。利用者が反社会的勢力またはその関係者であることが判明した場合、広島県は、利用者との本規約に基づく契約を解除し、利用者の利用資格を停止します。<br>
<br>
第21条（損害賠償）<br>
利用者の責めに帰すべき事由により本契約に関して広島県が損害を被った場合、本契約の解除の有無にかかわらず、利用者は広島県に生じた損害を賠償するものとします。<br>
<br>
第22条（規約の変更）<br>
１．広島県は、本規約を必要に応じて変更することがあります。本規約を変更された後のサービスに係る利用料その他の提供条件は、変更後の規約によります。<br>
&emsp;(1) 利用者の一般の利益に適合するとき<br>
&emsp;(2) 契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき<br>
２．本規約を変更するときは、広島県は、その変更により影響を受けることとなる利用者に対し、事前にその内容について広島県が適当と判断する方法で通知し、本サービス上で公表するものとします。<br>
<br>
第23条（紛争解決）<br>
１．本規約に定めのない事項または本規約の解釈上生じた疑義については、当事者が誠意をもって協議し、円満に解決するものとする。<br>
２．当事者間で、本規約または本サービスに関して争いが生じた場合、広島地方裁判所を第一審の専属的合意管轄裁判所とします。<br>
<br>
第24条（特約条項）<br>
本契約について、申込者と広島県が別途書面により特約した場合は、その特約は本契約と一体となり、本契約を補完および修正するものとします<br>。
<br>
【2022年9月12日制定】<br>
<br>
広島県<br>

      </v-card-text>
      <a name="privacy"></a>
      <div class="text-h4 mt-8">水産プラットフォーム  プライバシーポリシー</div>
      <v-card-text>
本サービスをご利用いただくにあたっては、水産プラットフォーム  プライバシーポリシー（以下「本プライバシーポリシー」といいます）をお読みいただき、内容についてご同意の上、ご利用いただくようお願いします。なお、本プライバシーポリシー内で使用する文言および用語は、「水産プラットフォーム利用規約」に定義された文言、または記載されている文言に準じます。<br>
<br>
第１条（取得する利用者情報について）<br>
広島県は、本サービスにおいて、以下に掲げる情報（以下「利用者情報」といいます）を利用者より取得します。利用者は、これらの利用者情報を広島県が取得し、サーバ上に保存することに同意するものとします。<br>
(1) 本サービスの利用者の以下に示す個人情報<br>
&emsp;① 氏名<br>
&emsp;② 会社名<br>
&emsp;③ メールアドレス<br>
&emsp;④ 電話番号<br>
&emsp;⑤ ユーザーID<br>
(2) 利用者の本サービスの利用状況<br>
&emsp;① 本サービスへのアクセス履歴および操作履歴<br>
&emsp;② 本サービスで利用者が入力した生産情報<br>
<br>
第２条（取得した利用者情報の利用目的）<br>
広島県は、広島県が取得した利用者情報を、以下の目的にのみ利用いたします。<br>
(1) 本サービスを提供するため、および本サービスの機能改善・向上のため。<br>
(2) 本サービスのシステムメンテナンス情報、利用者に登録頂いたアカウントの期限切れ情報を利用者に連絡するため。<br>
(3) 利用者が行うサービスの管理を遠隔操作することによって代行するため。<br>
(4) 利用者からのお問い合わせに対応するため。<br>
(5) 本サービス以外の新サービス等の開発・検討・提供にあたっての参考情報として利用するため（個人が特定される形で用いることはありません）。<br>
(6) 本サービス、本サービス専用のサービスサイトにかかる不具合等重要な注意事項が発生した場合に、利用者にお知らせするため<br>
<br>
第３条（利用者情報の第三者提供）<br>
以下のいずれかの場合を除き、利用者情報を第三者に提供しません。<br>
(1) あらかじめ利用者から同意を得た場合<br>
(2) 本サービスの運営について広島県漁業協同組合連合会と連携する場合<br>
(3) 利用者の所属する漁業協同組合から漁業権管理のために提供を求められた場合<br>
(4) 合併その他の事由による事業の承継に伴って利用者情報が提供される場合<br>
(5) 前号に掲げるもののほか、個人情報保護法その他の法令で認められる場合<br>
<br>
第４条（利用者情報の取扱いの委託）<br>
第2条（利用者情報の利用目的）記載の利用目的の達成のために、広島県および水産プラットフォームに関わる漁業指導者が利用者情報の保護に関する契約を締結する外部事業者に対し、利用者情報の取扱いを委託する場合があります。<br>
<br>
第５条（利用者情報に関するお客様からのお問合せ等）<br>
１．利用者情報の取得部門は以下のとおりです。<br>
&emsp;広島県農林水産局水産課&emsp;水産振興グループ<br>
&emsp;電話&emsp;082-513-3610<br>
&emsp;メール&emsp;nousuisan@pref.hiroshima.lg.jp<br>
<br>
&emsp;（委託業者）<br>
&emsp;シャープ株式会社&emsp;通信事業本部&emsp;ソリューション事業推進部<br>
&emsp;連絡先：https://k-tai.sharp.co.jp/business/<br>
<br>
２．利用者情報に関するお問合せは、下記のお問合せ窓口にご連絡ください。<br>
&emsp;問合せ先：nousuisan@pref.hiroshima.lg.jp <br>
<br>
第６条（本プライバシーポリシーの変更）<br>
１．広島県は、利用者情報のより適切な保護を図るため、または法令その他の規範の変更等に対応するため、利用者情報の取扱いに関する運用状況を適宜見直し、必要に応じて、本プライバシーポリシーを予告なく変更することがあります。<br>
<br>
【2022年9月12日制定】<br>
<br>
広島県<br>
      </v-card-text>
    </v-card>
    <v-row justify="center" class="mt-8" style="text-align: center">
      <template v-if="isSignIn && !tosAgreed">
        <v-col cols="6" sm="6" md="4" lg="3" xl="3">
          <v-btn width="200" color="grey white--text" @click.stop="deny"
            >同意しない</v-btn
          >
        </v-col>
        <v-col cols="6" sm="6" md="4" lg="3" xl="3">
          <v-btn width="200" color="primary" @click.stop="agree"
            >同意する</v-btn
          >
        </v-col>
      </template>
      <template v-else>
        <v-col cols="6" sm="6" md="4" lg="3" xl="3">
          <v-btn width="200" color="grey white--text" @click.stop="back"
            >戻る</v-btn
          >
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import Api from "@/logic/api/api.js";
import Account from "@/logic/api/account.js";
export default {
  methods: {
    agree() {
      // 利用規約に承認する
      this.$store.commit("setWaiting", true);
      Api.call("/tos", {
        tos_version: this.$store.getters.latestTosVersion,
      })
        .then(() => {
          // しばらくお待ちくださいを閉じる
          this.$store.commit("setWaiting", false);
          this.$store.commit("tosAgreed", this.$store.getters.latestTosVersion);
          this.$router.push("/product");
        })
        .catch((error) => {
          // しばらくお待ちくださいを閉じる
          this.$store.commit("setWaiting", false);
          Api.resolve(error);
        });
    },
    deny() {
      Account.signOut(this.$store, this.$router);
    },
    back() {
      this.$router.back();
    },
  },
  computed: {
    tosAgreed() {
      return this.$store.getters.isTosAgree;
    },
    isSignIn() {
      return Account.isSignIn(this.$store);
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
